// /join-a-network — public ad-entry landing for the "join-network" journey
// with no target network. Generic network ads link here; the signup finishes
// on the Networks directory where the member picks her own. Network-targeted
// ads use the /join-a-network/:slug sibling, whose slug drives attribution
// and the post-signup auto-join.

import { useEffect } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { EntryJourneyLanding } from '@/components/entry-journeys';
import { useEntryJourneyCopy } from '@/components/entry-journeys/journey-copy';
import { writeEntryJourney } from '@/lib/entry-journey';
import { refSearchParam, storeSignupRef } from '@/lib/signup-ref-cookie';

export const Route = createFileRoute('/_public/join-a-network/')({
  // Signed-in visitors browse the Networks directory instead of the pitch;
  // mid-onboarding visitors re-enter the journey onboarding (see the layout
  // gate exemption in _public.tsx) — with no target network stashed, their
  // finish also lands on the directory.
  beforeLoad: ({ context }) => {
    if (context.session !== null) {
      if (
        context.member !== null &&
        context.member.onboardingCompletedAt === null
      ) {
        writeEntryJourney('join-network');
        throw redirect({ to: '/onboarding/j/about' });
      }
      throw redirect({ to: '/networks' });
    }
  },
  validateSearch: (search: Record<string, unknown>) => refSearchParam(search),
  component: JoinNetworkGenericEntryPage,
});

function JoinNetworkGenericEntryPage() {
  const { ref } = Route.useSearch();
  // Cookie the campaign ref on arrival (signed-out only — beforeLoad already
  // bounced signed-in visitors) so it survives the signup + OAuth round-trip;
  // /auth/finishing claims it. No auto-join here: the generic landing names
  // no network.
  useEffect(() => {
    if (ref !== undefined) storeSignupRef(ref);
  }, [ref]);
  return (
    <EntryJourneyLanding
      journey="join-network"
      {...useEntryJourneyCopy('join-network')}
    />
  );
}
